import { useState, memo } from 'react';
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';
import './ImageZoomViewer.css';

type ZoomControlsProps = {
  scale: number;
};

const ZOOM_STEP = 0.25;

const ZoomControls = ({ scale }: ZoomControlsProps) => {
  const { zoomIn, zoomOut, resetTransform } = useControls();
  const zoomPercent = Math.round(scale * 100);

  return (
    <div className="zoom-controls">
      <button
        className="zoom-controls__btn"
        onClick={() => zoomOut(ZOOM_STEP)}
        title="Zoom out"
        aria-label="Zoom out"
      >
        −
      </button>
      <span className="zoom-controls__level">{zoomPercent}%</span>
      <button
        className="zoom-controls__btn"
        onClick={() => zoomIn(ZOOM_STEP)}
        title="Zoom in"
        aria-label="Zoom in"
      >
        +
      </button>
      <button
        className="zoom-controls__btn zoom-controls__btn--reset"
        onClick={() => resetTransform()}
        title="Reset zoom"
        aria-label="Reset zoom"
      >
        Reset
      </button>
    </div>
  );
};

type ImageZoomViewerProps = {
  src: string;
  alt: string;
};

export const ImageZoomViewer = memo(function ImageZoomViewer({ src, alt }: ImageZoomViewerProps) {
  const [scale, setScale] = useState(1);

  return (
    <TransformWrapper
      initialScale={1}
      minScale={0.25}
      maxScale={5}
      centerOnInit={true}
      limitToBounds={false}
      wheel={{ smoothStep: 0.1 }}
      doubleClick={{ mode: 'reset' }}
      panning={{ velocityDisabled: true }}
      onTransformed={(_ref, state) => {
        setScale(state.scale);
      }}
    >
      <ZoomControls scale={scale} />
      <TransformComponent
        wrapperClass="image-zoom-viewer__wrapper"
        contentClass="image-zoom-viewer__content"
      >
        <img
          src={src}
          alt={alt}
          className="image-zoom-viewer__image"
          draggable={false}
        />
      </TransformComponent>
    </TransformWrapper>
  );
});
